import React from "react";
import "./../../assets/css/ToggleSwitch.css";

const ToggleSwitch = (props) => {
  const { id, label_left, onChange, checked, label_right, className, name} = props;

  return (
    <div className={`${className} font-size-12 d-flex rounded py-1 justify-content-around`} style={{border: `1px solid #CCCCCC`}}>
      <span className="m-0 opacity-75" style={{paddingTop: '2px'}}>{label_left}{" "}</span>
      <div className="toggle-switch">
        <input
          id={id}
          type="checkbox"
          className="checkbox"
          name={name}
          onChange={onChange}
          checked={checked}
        />
        <label className="label" htmlFor={id}>
          <span className="inner" />
          <span className="switch" />
        </label>
      </div>
      <span className="m-0 opacity-75" style={{paddingTop: '2px'}}>{" "}{label_right}</span>
    </div>
  );
};

export default ToggleSwitch;
